import { InstrumentIcon, PaymentModuleId } from '@foundation/apis/payments';

export const InstrumentIconForModuleId: {
  [k in PaymentModuleId]: InstrumentIcon;
} = {
  [PaymentModuleId.BraintreeCard]: InstrumentIcon.GenericCard,
  [PaymentModuleId.WorldpayCard]: InstrumentIcon.GenericCard,
  [PaymentModuleId.WorldpayJCB]: InstrumentIcon.Jcb,
  [PaymentModuleId.BraintreePayPal]: InstrumentIcon.PayPal,
  [PaymentModuleId.BraintreePayPalPayLater]: InstrumentIcon.PayPal,
  [PaymentModuleId.Transbank]: InstrumentIcon.TransbankWebpay,
  [PaymentModuleId.PaymentAtSubsidiary]: InstrumentIcon.Subsidiary,
  [PaymentModuleId.Sepa]: InstrumentIcon.SEPA,
  [PaymentModuleId.WorldpayIdeal]: InstrumentIcon.Ideal,
  [PaymentModuleId.BraintreeApplePay]: InstrumentIcon.ApplePay,
  [PaymentModuleId.WorldpayBancontact]: InstrumentIcon.Bancontact,
  [PaymentModuleId.BraintreeGooglePay]: InstrumentIcon.GooglePay,
  [PaymentModuleId.DirectDebitLSV]: InstrumentIcon.DirectDebit,
  [PaymentModuleId.DirectDebitPostFinance]:
    InstrumentIcon.DirectDebitPostFinance,
  [PaymentModuleId.ECommerceConnect]: InstrumentIcon.ECommerceConnect,
  [PaymentModuleId.NuveiTwint]: InstrumentIcon.NuveiTwint,
  [PaymentModuleId.FlutterwaveCreditCard]: InstrumentIcon.GenericCard,
  [PaymentModuleId.NuveiCreditCard]: InstrumentIcon.GenericCard,
  [PaymentModuleId.BraintreeSepa]: InstrumentIcon.SEPA,
  [PaymentModuleId.PaymentOnDelivery]: InstrumentIcon.Delivery,
  [PaymentModuleId.BankTransfer]: InstrumentIcon.BankTransfer,
  [PaymentModuleId.Finvoice]: InstrumentIcon.DirectDebit,
  [PaymentModuleId.TwoCTwoP]: InstrumentIcon.OnlinePayment,
  [PaymentModuleId.ProcessingKZ]: InstrumentIcon.OnlinePayment,
  [PaymentModuleId.Yookassa]: InstrumentIcon.OnlinePayment,
  [PaymentModuleId.RazorPay]: InstrumentIcon.OnlinePayment,
  [PaymentModuleId.DenizBank]: InstrumentIcon.DenizBank,
  [PaymentModuleId.PaymentInSubsidiaryCashOnPickup]: InstrumentIcon.Subsidiary,
  [PaymentModuleId.PaymentInSubsidiaryCardViaTerminalOnPickup]:
    InstrumentIcon.Subsidiary,
  [PaymentModuleId.PayByInvoice]: InstrumentIcon.PayByInvoice,
  [PaymentModuleId.WorldpayKlarna]: InstrumentIcon.Klarna,
};
